import type { Synonyms } from '../@types/Synonym';
import type { Actions } from '../actions';
import {
  RCV_DELETE_SYNONYM_VEHICLE,
  RCV_LIST_SYNONYM_VEHICLE,
  RCV_POST_SYNONYM_VEHICLE,
  RCV_PUT_SYNONYM_VEHICLE,
  REQ_DELETE_SYNONYM_VEHICLE,
  REQ_LIST_SYNONYM_VEHICLE,
  REQ_POST_SYNONYM_VEHICLE,
  REQ_PUT_SYNONYM_VEHICLE,
  REQUEST_FAILED,
} from '../actions/synonym-vehicle';
import { requestStatus, responseStatus } from '../shared/statuses';

interface SynonymVehicleState {
  requestStatus: number;
  responseStatus: number;
  synonyms: Synonyms | null;
}

const _initialState: SynonymVehicleState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  synonyms: null,
};

let synonyms: Synonyms;
let index: number;
const synonymVehicleReducer = (
  state: SynonymVehicleState = _initialState,
  action: Actions,
): SynonymVehicleState => {
  switch (action.type) {
    case REQ_LIST_SYNONYM_VEHICLE:
      return {
        ...state,
        synonyms: null,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_LIST_SYNONYM_VEHICLE:
      return {
        ...state,
        synonyms: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_POST_SYNONYM_VEHICLE:
      return {
        ...state,
        requestStatus: requestStatus.CREATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_POST_SYNONYM_VEHICLE:
      synonyms = state.synonyms ? { ...state.synonyms } : { docs: [] };
      synonyms.docs = state.synonyms?.docs.slice(0) || [];
      if (action && action.response) {
        synonyms.docs.push(action.response);
      }
      return {
        ...state,
        synonyms,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_PUT_SYNONYM_VEHICLE:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_PUT_SYNONYM_VEHICLE:
      synonyms = state.synonyms ? { ...state.synonyms } : { docs: [] };
      synonyms.docs = state.synonyms?.docs.slice(0) || [];
      index = synonyms.docs.findIndex(
        (x) => x.term.toLowerCase() === action.response.term.toLowerCase(),
      );
      if (index > -1) {
        synonyms.docs[index] = action.response;
      }
      return {
        ...state,
        synonyms,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_DELETE_SYNONYM_VEHICLE:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_DELETE_SYNONYM_VEHICLE:
      synonyms = state.synonyms ? { ...state.synonyms } : { docs: [] };
      synonyms.docs = state.synonyms?.docs.slice(0) || [];
      index = synonyms.docs.findIndex((x) => x.term.toLowerCase() === action.term.toLowerCase());
      if (index > -1) {
        synonyms.docs.splice(index, 1);
      }
      return {
        ...state,
        synonyms,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default synonymVehicleReducer;
